import { combineReducers } from "redux";
import data, * as dataSelectors from "./data";
import ui, * as uiSelectors from "./ui";
import pointInPolygon from "@turf/boolean-point-in-polygon";
import turfPoint from "turf-point";
import { centerFromProject } from "../modules/project";
import { createSelector } from "reselect";

export default combineReducers({ data, ui });

//Data
export const selectGeoJSON = s => dataSelectors.selectGeoJSON(s.data);
export const selectAllHubs = s => dataSelectors.selectAllHubs(s.data);
//UI
export const selectActiveFeature = s => uiSelectors.selectActiveFeature(s.ui);
export const selectSearchBarVisible = s =>
    uiSelectors.selectSearchBarVisible(s.ui);
export const selectSearchedLocation = s =>
    uiSelectors.selectSearchedLocation(s.ui);
export const selectActiveProject = s => uiSelectors.selectActiveProject(s.ui);
export const selectActiveFilters = s => uiSelectors.selectActiveFilters(s.ui);
export const selectBasemap = s => uiSelectors.selectBasemap(s.ui);
export const selectActivePage = s => uiSelectors.selectActivePage(s.ui);
export const selectViewingHub = s => uiSelectors.selectViewingHub(s.ui);
export const selectMapType = s => uiSelectors.selectMapType(s.ui);
export const selectIsInternal = s => uiSelectors.selectIsInternal(s.ui);
export const selectZoomToNsw = s => uiSelectors.selectZoomToNsw(s.ui);

// Combined selectors

export const selectFilteredProjects = s =>
    dataSelectors.selectFilteredProjects(
        selectActiveFilters(s),
        selectViewingHub(s),
        s.data
    );
export const selectActiveProjects = s => {
    const activeProject = selectActiveProject(s);
    if (!activeProject) return [];
    const projects = selectFilteredProjects(s);

    return projects.filter(x => {
        return (
            parseFloat(x.Latitude) === parseFloat(activeProject.Latitude) &&
            parseFloat(x.Longitude) === parseFloat(activeProject.Longitude)
        );
    });
};
export const selectFilteredProjectsInActiveFeature = createSelector(
    selectActiveFeature,
    selectFilteredProjects,
    (activeFeature, projects) => {
        if (!activeFeature) return projects;
        return projects.filter(p => {
            return pointInPolygon(
                turfPoint(centerFromProject(p)),
                activeFeature
            );
        });
    }
);



// WEBPACK FOOTER //
// ./src/reducers/index.js